import React from "react";
import styles from "./individualEvent.module.css";import { ApplicationEvent } from "../../../../../../../../Models/applicationModels";
import { formatUTCDateTime } from "../../../../../../../../utils/formatUTCDate";
import { EVENT_TYPE_COLORS, EVENT_TYPES } from "../../eventHistory.constants";

interface IndividualEventProps {
    event: ApplicationEvent;    
}

export const IndividualEvent = ({ event }: IndividualEventProps) => {
    const aliasColor = EVENT_TYPE_COLORS[event.eventType as EVENT_TYPES] ?? { primary: '#6B7280', secondary: '#F3F4F6' };
    const canRenderAlias = !!event.eventAlias;
    return (
        <div className={styles.individualEventContainer}>
            <div className={styles.eventTitle}>
                <div className={styles.eventTitleText}>{event.eventName}</div>
                {canRenderAlias && (
                    <div className={styles.eventAlias} style={{ background: aliasColor.secondary, color: aliasColor.primary, boxShadow: `0 0 1px 0 ${aliasColor.primary + 'B2'}` }}>{event.eventAlias}</div>
                )}
            </div>
            <p className={styles.eventCreatedOn}>{formatUTCDateTime(event.createdOn, false, true)}</p>
        </div>
    ) 
}   
